export default __webpack_public_path__ + "static/media/0x6968105460f67c3bf751be7c15f92f5286fd0ce5.878c1c0d.jpeg";